import React, { useState, ReactNode } from 'react';
import YesNoDialog from '@/components/dialogs/YesNoDialog';
import { Button } from '@/components/Buttons';
import { ButtonProps } from './Button';
import { ButtonColor } from './ButtonElement';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { TranslatableText } from '@/types';

export interface ConfirmButtonProps extends ButtonProps {
    onConfirm(): any;
    dialogTitle: ReactNode;
    dialogBody: ReactNode;
    dialogConfirmButtonColor?: ButtonColor;
    dialogCancelButtonColor?: ButtonColor;
    skipDialog?: boolean;
    confirmButtonText?: TranslatableText;
    cancelButtonText?: TranslatableText;
}

const ConfirmButton = React.forwardRef<HTMLElement, ConfirmButtonProps>(
    (
        {
            onConfirm,
            dialogTitle,
            dialogBody,
            dialogConfirmButtonColor,
            dialogCancelButtonColor,
            onClick,
            skipDialog = false,
            confirmButtonText,
            cancelButtonText,
            ...buttonProps
        },
        ref
    ) => {
        const [showDialog, setShowDialog] = useState(false);

        const handleClick = (e) => {
            if (skipDialog) {
                onConfirm();
            } else {
                setShowDialog(true);
                triggerHandler(onClick, e);
            }
        };

        const handleDialogClose = () => {
            setShowDialog(false);
        };

        return (
            <React.Fragment>
                <Button {...buttonProps} onClick={handleClick} ref={ref} />
                <YesNoDialog
                    title={dialogTitle}
                    body={dialogBody}
                    show={showDialog}
                    onAccept={onConfirm}
                    onClose={handleDialogClose}
                    confirmButtonColor={dialogConfirmButtonColor}
                    cancelButtonColor={dialogCancelButtonColor}
                    confirmButtonText={confirmButtonText}
                    cancelButtonText={cancelButtonText}
                />
            </React.Fragment>
        );
    }
);

export default ConfirmButton;
